import { connect } from 'react-redux';
import CancelMembershipPage from 'pages/CancelMembershipPageNew';
import newOlsActions from 'store/newOls/actions';
import membershipFormsActions from 'store/membershipForms/actions';

const mapStateToProps = state => {
  return {
    cancelDropdownDetails: state.membershipForms.cancelDropdownDetails,
    isSubmitCancelLoading: state.membershipForms.isSubmitCancelLoading,
    cancelFormDetails: state.membershipForms.cancelFormDetails,
  };
};
const mapDispatchToProps = {
  loadCancelDropdownData: membershipFormsActions.Creators.loadCancelDropdownDataRequest,
  submitCancelForm: membershipFormsActions.Creators.submitCancelRequest,
  resetCancelFormDetails: membershipFormsActions.Creators.resetCancelFormDetails,
};
export default connect(mapStateToProps, mapDispatchToProps)(CancelMembershipPage);
